import React from 'react';
import { FormLabel, Stack } from '@mui/material';
import { UndoFieldButton } from './UndoFieldButton';

/**
 * An admin drawer field's label (children), with an undo icon on the right while Formik
 * field `name` has changed (UndoFieldButton). required marks the label with an asterisk.
 * Checkboxes don't use it.
 */
export const AdminFieldLabel = ({ name, required = false, children }) => (
	<Stack direction='row' alignItems='center' justifyContent='space-between' spacing={1}>
		<FormLabel required={required}>{children}</FormLabel>
		<UndoFieldButton name={name} />
	</Stack>
);
